module.exports = __webpack_public_path__ + "img/秋菊高潔_四方連續_彩稿.eeab5cb6.png";